/**
 * The simple view's "In this conversation" column (owner 2026-10-31: a docked, resizable, collapsible column beside the
 * conversation). It lists what the conversation works on; opening one shows that record's own screen here, in place of
 * the list (the Spec 76 panel host, docked), with Back to the list and a link to its full page.
 */
import { X } from 'lucide-react';
import type React from 'react';
import { getPanelType } from '../../context-panel/registry.js';
import { ContextPanel } from '../../context-panel/ContextPanel.js';
import { useContextPanel } from '../../context-panel/url-state.js';
import { Button } from '../../ui/Button.js';
import { ConversationEntitiesList } from './ConversationEntitiesList.js';

interface ConversationEntitiesColumnProps {
  conversationId: string;
  newestMessageId: string | null;
  onClose: () => void;
  /** Its own title row; off inside a `Sheet`, which has one. */
  showHeader?: boolean;
}

export const ConversationEntitiesColumn: React.FC<ConversationEntitiesColumnProps> = ({
  conversationId,
  newestMessageId,
  onClose,
  showHeader = true,
}) => {
  const { panel } = useContextPanel();
  const showsRecord = panel !== null && getPanelType(panel.type) !== null;

  return (
    <div className="flex h-full min-h-0 min-w-0 flex-col border-l bg-surface">
      {showsRecord ? (
        <ContextPanel layout="docked" />
      ) : (
        <>
          {showHeader && (
            <div className="flex shrink-0 items-center justify-between gap-2 border-b px-4 py-3">
              <h2 className="m-0 text-sm font-medium text-heading">In this conversation</h2>
              <Button variant="ghost" size="sm" iconOnly onClick={onClose} aria-label="Close this panel">
                <X size={16} aria-hidden />
              </Button>
            </div>
          )}
          <div className="min-h-0 flex-1 overflow-y-auto p-4">
            <ConversationEntitiesList conversationId={conversationId} newestMessageId={newestMessageId} />
          </div>
        </>
      )}
    </div>
  );
};
